import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { useStyles } from './styles';

interface ThankYouScreenProps {
  onClose: () => void;
}

const ThankYouScreen: React.FC<ThankYouScreenProps> = ({ onClose }) => {
  const classes = useStyles();

  return (
    <Box sx={classes.container}>
      <Box sx={classes.closeButtonContainer}>
        <Button onClick={onClose} sx={classes.closeButton}>
          <Typography sx={classes.closeButtonText}>✕</Typography>
        </Button>
      </Box>

      <Box sx={classes.contentContainer}>
        <Typography sx={classes.title}>Thank you!</Typography>
        <Typography sx={classes.message}>
          Your feedback helps us create memorable
          <br />
          first steps for every new joiner.
        </Typography>
      </Box>
    </Box>
  );
};

export default ThankYouScreen;
